export const FEATURE_FLAG_FIRST_LOAD_TIMEOUT_MS = 500;
export const FEATURE_FLAG_FIRST_LOAD_ERROR_TIMEOUT_MS = 5000;
export const FEATURE_FLAG_UPDATE_INTERVAL_MS = 60000;
